/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 Articles = {
    vote: function(e) {
        var button = $(this);

        if (button.hasClass('disabled')) {
            return false;
        }

        var id   = button.data('id');
        var type = button.data('type');

        if (id > 0) {
            button.addClass('disabled');

            $.ajax({
                url: '/a/viewArticle/votes/send',
                type: 'POST',
                dataType: 'json',
                data: {
                    'id': id,
                    'type': type
                },
            }).done(function(data) {
                button.removeClass('disabled');

                if (data.status == "error") {
                    var message = "";

                    for (i = data.messages.length - 1; i >= 0; i--) {
                        message += data.messages[i];

                        if (i > 0) {
                            message += '<br>';
                        }
                    }

                    Alertbox({
                        title: "Erro ao votar",
                        content: message,
                        type: 'error'
                    });
                } else if (data.status == "success") {
                    var pos = $(".article-vote[data-type='positive']");
                    var neg = $(".article-vote[data-type='negative']");

                    if (type == 'positive') {
                        pos.toggleClass('active');

                        if (neg.hasClass('active')) {
                            neg.removeClass('active');
                        }
                    } else if (type == 'negative') {
                        neg.toggleClass('active');

                        if (pos.hasClass('active')) {
                            pos.removeClass('active');
                        }
                    }

                    pos.parent().find('.number').text(data.votes.positive);
                    neg.parent().find('.number').text(data.votes.negative);
                }
            });
        }
    },
    comments: {
        reply: function(e) {
            e.preventDefault();

            var form = $(this);

            if (form.hasClass('disabled')) {
                return false;
            }

            var input  = form.find(".reply-input");

            var comment = input.val();

            if (comment === '') {
                form.effect('shake', { distance: 3 });
            } else {
                var idComment = form.data('id');

                form.addClass('disabled').animate({'opacity': 0.5});

                $.ajax({
                    url: '/a/viewArticle/comments/reply',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        'id': idComment,
                        'comment': comment
                    }
                }).done(function(data) {
                    form.removeClass('disabled').animate({'opacity': 1});

                    if (data.status == "error") {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao enviar comentário",
                            content: message,
                            type: 'error'
                        });
                    } else if (data.status == "success") {
                        input.val('');
                        $("#article-comment-replies-"+idComment).append(data.html);
                    }
                });
            }
        },
        send: function(e) {
            e.preventDefault();

            var form = $(this);

            if (form.hasClass('disabled')) {
                return false;
            }

            var input  = form.find("#message-input");
            var comment = input.val();

            if (comment === '') {
                form.find('.write').effect('shake', { distance: 3 });
            } else {
                form.addClass('disabled').animate({'opacity': 0.5});

                var idArticle = form.data('id');

                $.ajax({
                    url: '/a/viewArticle/comments/send',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        'id': idArticle,
                        'comment': comment
                    }
                }).done(function(data) {
                    form.removeClass('disabled').animate({'opacity': 1});

                    if (data.status == "error") {
                        var message = "";

                        for (i = data.messages.length - 1; i >= 0; i--) {
                            message += data.messages[i];

                            if (i > 0) {
                                message += '<br>';
                            }
                        }

                        Alertbox({
                            title: "Erro ao enviar comentário",
                            content: message,
                            type: 'error'
                        });
                    } else if (data.status == "success") {
                        input.val('');

                        $(".comments-empty-area").parent().remove();
                        $(".article-list-box-comment").append(data.html);

                        Main.plugins.tooltip();

                        var el = $(".article-list-box-comment > div:last-child");

                        $("html, body").animate({
                            scrollTop: el.offset().top
                        },'slow');
                    }
                });
            }
        },
    },
    init: function() {
        $(".article-content a > img.ampliar").parent().fancybox();

        $(".article-vote").on('click', Articles.vote);

        $(".article-list-box-comment").on({
            mouseenter: function () {
                $(this).find('.form-reply').stop(true, true).fadeIn();
            },
            mouseleave: function () {
                var input = $(".reply-input").val();

                if (input.length == 0) {
                    $(this).find('.form-reply').stop(true, true).fadeOut();
                }
            }
        }, ".article-box-comment");

        $(".article-list-box-comment").on('submit', '.form-reply', Articles.comments.reply);

        $("#article-form-comment").on('submit', Articles.comments.send);
    }
};
